export default __webpack_public_path__ + "static/media/approval-bg.7693de02.jpg";